<template>
  <div v-if="renderComponent">
    <div>
      <h5 class="vue-title pull-left custom-header">
        <strong>{{ $t("ADMIN") }}</strong>
      </h5>
      <p
        class="float-right btn-add-partner"
        v-if="checkPermisssion('PARTNER_ADMIN', false)"
      >
        {{ $t("ADD") }}
        <a href="#/createPartnerUser">
          <em class="fas fa-plus-circle"></em>
        </a>
      </p>
      <b-input-group
       class="pull-right search-text-box"
      >
        <template v-slot:prepend>
          <b-input-group-text>
            <em class="fa fa-search" @click="onSerach"></em>
          </b-input-group-text>
        </template>
        <b-form-input
          size="sm"
          @keyup.enter="onSerach"
          autocomplete="off"
          v-model="searchKeyword"
        ></b-form-input>
      </b-input-group>
    </div>
    <c-table
      :table-data="partnerUserList.list"
      :fields="fields"
      :per-page="10"
      striped
      hover
      :total="partnerUserList.pageTotal"
      :update="showModalStatus"
      :edit="editUser"
      :delete="showDeleteModal"
      :sortTable="sortTable"
      :isBusy="isBusy"
      :pagination="pagination"
      :countPerPage="currentPage"
    ></c-table>
    <nav>
      <div class="pagination-module">
        <b-pagination
          :total-rows="partnerUserList.pageTotal"
          @change="pagination"
          :per-page="10"
          v-model="currentPage"
          :prev-text="$t('FORWARD')"
          :next-text="$t('NEXT')"
        />
      </div>
    </nav>
    <b-modal id="modal-delete" hide-footer>
      <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}</template>
      <p class="my-2 wrapText">
        {{
          selectedItemForDelete.last_name +
            " " +
            selectedItemForDelete.first_name
        }}
        {{ $t("DELETECONFIRMATIONCOMMOM") }}
      </p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-danger"
            class="buttons-align-right"
            size="sm"
            @click="deleteItem()"
            >{{ $t("DELETE") }}</b-button
          >
          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="$bvModal.hide('modal-delete')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-Status" hide-footer @hidden="close()">
      <template v-slot:modal-title>{{
        $t("STATUSCHANGECONFIRMATION")
      }}</template>
      <p>ステータスを変更してもよろしいですか？</p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="buttons-align-right"
            @click="StatusChange()"
            >{{ $t("SUBMIT") }}</b-button
          >

          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="close"
          >
            {{ $t("CANCEL") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import {
  DELETE_PARTNER_USER,
  USER_PARTNER_LIST,
  CHANGE_PARTNER_USER_STATUS
} from "@/store/actions.type";
import cTable from "@/components/Table.vue";
import { checkPermisssion } from "@/shared/utils.js";

export default {
  name: "user-list  ",
  data() {
    return {
      searchKeyword: "",
      renderComponent: true,
      currentPage: 1,
      checkPermisssion: checkPermisssion,
      selectedItemForDelete: "",
      sortField: "",
      sortDirection: false,
      isBusy: true
    };
  },
  computed: {
    ...mapGetters(["partnerUserList"])
  },
  components: { cTable },
  methods: {
    /**
     * Show Delete Modal
     * Input @param {object} row Seleted Row to Delete
     * Output PopUp the Delete Modal
     */
    showDeleteModal(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-delete");
    },

    /**
     * Edit the table row
     * Input @param {Number} userId Seleted Row id to Edit
     * Output  @param {Number} userId  append to routing Params then Redirect to edit page
     */
    editUser(row) {
      this.$router.push({
        name: "editPartnerUser",
        params: { id: row.id }
      });
    },
    /**
     * Status function for table Row
     * Input 1,@param {Number} userID  selected Row ID 2,@param {string} status  (Active or Inactive)
     * Output @param {boolean}   data.status  status of the api call (true or false)
     */
    async StatusChange() {
      this.$bvModal.hide("modal-Status");
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let selectedItemId = _.get(this.selectedItemForDelete, "id", 0);
      this.$bvModal.hide("modal-Status");
      if (selectedItemId) {
        let status = _.get(this.selectedItemForDelete, "status", "");
        let response = await this.$store.dispatch(CHANGE_PARTNER_USER_STATUS, {
          id: selectedItemId,
          status: status == "active" ? "inactive" : "active"
        });
        this.isLoading.hide();
        this.isBusy = true;
        this.pagination(this.currentPage);
        if (_.get(response, "status", false)) {
          this.$toast.success({
            message: _.get(response, "message", "")
          });
        } else {
          this.$toast.error({
            message: _.get(response, "message", "")
          });
        }
      }
    },
    /**
     * Show Status Change Modal
     * Input @param {object} row Seleted Row to Change status of it
     * Output PopUp the Status Change Modal
     */
    showModalStatus(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-Status");
    },
    /**
     * Show Delete Modal
     * Input @param {object} row Seleted Row to Delete
     * Output PopUp the Delete Modal
     */
    async deleteItem() {
      this.$bvModal.hide("modal-delete");

      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let response = await this.$store.dispatch(DELETE_PARTNER_USER, {
        id: this.selectedItemForDelete.id
      });

      this.isLoading.hide();
      if (_.get(response, "status", false)) {
        this.$toast.success({
          message: _.get(response, "message", "")
        });
        if (this.partnerUserList.list.length === 1) {
          this.pagination(1);
        } else {
          this.pagination(this.currentPage);
        }
      } else {
        this.$toast.error({
          message: _.get(response, "message", "")
        });
      }
    },
    /**
     * Sort function on  table
     * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
     * Output @param {List}   response.list  Filtered List
     */
    async sortTable(field, direction) {
      this.isBusy = true;
      this.sortField = field;
      this.sortDirection = direction;
      await this.$store.dispatch(USER_PARTNER_LIST, {
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage
      });
      this.isBusy = false;
    },
    /*Pagination */
    pagination(page) {
      this.loadTableData(page);
    },
    /**
     * To load the table data
     * Input @param {page} currentPageCount the page number of data you want
     * Output {object} table data
     */
    async loadTableData(page) {
      this.currentPage = page;
      this.isBusy = true;
      await this.$store.dispatch(USER_PARTNER_LIST, {
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage
      });
      this.isBusy = false;
    },

    close() {
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    /**
     * onSearch function on  table
     * Input @param {String} search_query Search keyword
     * Output @param {List}   response.list  Filtered List
     */
    onSerach() {
      this.pagination(1);
    }
  },
  created() {
    this.$store
      .dispatch(USER_PARTNER_LIST, { field: "id", sort: "desc" })
      .then(data => {
        this.isBusy = false;
      });
    this.fields = [
      {
        key: "user.userid",
        label: this.$t("ID"),
        class: "text-left",
        sortable: true
      },
      {
        key: "first_last_name",
        label: this.$t("FULLNAME"),
        class: "text-left",
        sortable: true
      },
      {
        key: "email",
        label: this.$t("MAILADDRESS"),
        sortable: true,
        class: "text-left"
      },
      {
        key: "contact_no",
        label: this.$t("MOBILE"),
        sortable: true,
        class: "text-left"
      },
      {
        key: "user.role.name",
        label: this.$t("AUTHORITY"),
        sortable: true,
        class: "text-left"
      }
    ];
    if (checkPermisssion("PARTNER_ADMIN", false)) {
      this.fields.push({
        key: "status",
        label: this.$t("STATUS"),
        sortable: false
      });
      this.fields.push({
        key: "actions",
        label: this.$t("ACTION"),
        sortable: false
      });
    } else {
      this.fields.push({
        key: "status_disable",
        label: this.$t("STATUS"),
        sortable: false
      });
    }
  }
};
</script>
<style scoped>
.addBtn {
  font-size: 17px;
  margin-top: 14px;
  margin-left: 20px;
}
.search {
  width: 200px;
  margin: 10px 0px;
  height: 10px;
}
.btn-add-partner {
  font-size: 17px;
  margin-top: 14px;
  margin-left: 20px;
}
.search-text-box {
  width: 200px;
  margin: 10px 0px;
}
</style>
